import {createContext} from 'react';

const FABContext = createContext();
FABContext.displayName = 'FABContext';
export default FABContext;